module.exports = __webpack_public_path__ + "static/media/corporate-services-icon.10f6bda7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/corporate-services-icon.svg
// module id = 1920
// module chunks = 0